import { render, staticRenderFns } from "./DisplayCategoryPriorityIframe.vue?vue&type=template&id=bf00ab26&"
import script from "./DisplayCategoryPriorityIframe.vue?vue&type=script&lang=ts&"
export * from "./DisplayCategoryPriorityIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports